module.exports = __webpack_public_path__ + "static/media/grownUpsGrass.7e001d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/ui/grownUpsGrass.png
// module id = 389
// module chunks = 0